

import { Component, OnDestroy, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { CookieService } from 'ngx-cookie-service';
import { Router, NavigationEnd } from '@angular/router';
import nc3navigation from 'src/assets/nc3-navigation-native/nc3navigation';
import { NavbarService } from './navbar.service';

import { DomService } from '../dom/dom.service';
import { XSRF_TOKEN } from 'src/app/const/xsrf-token';
import { WindowRef } from '../domain/window-ref';
import { ProfileService } from '../auth/profile.service';
import { AuthService } from '../auth/auth.service';
import { CONTEXT_TYPE } from 'src/app/const/context-type';
import { PATH } from 'src/app/const/path';
import { DomainService } from '../domain/domain.service';
import { Subscription } from 'rxjs';

@Component({
    selector: 'admin-navbar',
    template: '',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: true
})
export class NavbarComponent implements OnInit, OnDestroy {

  private readonly translationIndex = 'navbar';

  private readonly hashcode$ = new Subscription();
  private logout$ = new Subscription();
  private loginUrl$ = new Subscription();

  constructor(private readonly auth: AuthService, private readonly pfs: ProfileService, private readonly domain: DomainService,
    private readonly service: NavbarService, private readonly dom: DomService,
    private readonly cookieService: CookieService,
    private readonly router: Router, private readonly windowRef: WindowRef) { }

  ngOnInit() {
    const contextId = String(this.pfs.profile.id);
    const language = this.pfs.profile.language;
    this.dom.setLangAttribute(language);
    const item = this.service.getProfileNavItem(this.pfs.profile, this.windowRef.getHostname());

    const navbarOptions = {
      contextId: contextId,
      allowedContextTypes: `${CONTEXT_TYPE.visma},${CONTEXT_TYPE.distributor}`,
      menu: item.menu,
      menuItemsEndpoint: 'webapi/rest/vismamenu/v1/items',
      prefix: 'Visma.net',
      baseUrl: this.domain.getBaseUrl(this.windowRef.getHostname()),
      language: language,
      xsrfToken: this.cookieService.get(XSRF_TOKEN.cookieName),
      translations: this.pfs.messages[this.translationIndex],
    };


    this.initNavigation(navbarOptions);

    this.router.events.forEach((event) => {
      if (event instanceof NavigationEnd) {
        if (event.url !== '' && event.url !== '/') {
          if (event.url !== PATH.not_found && event.url !== PATH.forbidden) {
            this.dom.setPageTitle(event.url);
            this.service.setProfileItems(contextId, event.url);
            nc3navigation.setMenuActiveItems();
          }
        }
      }
    });
  }

  ngOnDestroy(): void {
    this.hashcode$.unsubscribe();
    this.logout$.unsubscribe();
    this.loginUrl$.unsubscribe();
  }


  private initNavigation(navbarOptions: any): void {
    let options: nc3navigation.Options = {
      baseUrl: navbarOptions.baseUrl,
      restFulPath: {
        menuItems: navbarOptions.menuItemsEndpoint,
        lastLoginTime: 'webapi/rest/vismamenu/getLastLogin',
        itemsSearch: 'webapi/rest/vismamenu/v1/itemsSearch',
        itemsByType: 'webapi/rest/vismamenu/itemsByType'
      },
      language: navbarOptions.language,
      fallbackLanguage: 'en',
      pathFieldName: 'path',
      selectedAppPrefix: navbarOptions.prefix,
      httpHeaders: [
        { name: 'x-xsrf-token', value: navbarOptions.xsrfToken },
        { name: 'Visma-ContextId', value: navbarOptions.contextId }
      ],
      withCredentials: true,
      callback: {},
      allowedContextTypes: navbarOptions.allowedContextTypes,
      firstLevelMenu: navbarOptions.menu.firstLeveLMenu,
      secondLevelMenu: navbarOptions.menu.secondLevelMenu,
      hasFeedback: false,
      hasNotifications: false,
      hasHelp: false,
      translations: navbarOptions.translations,
      usesQueryParams: true,
      limitForTypeaheadResults: 150,
      icons: []
    };

    options.callback = {
      onComponentReady: () => {
      },
      onChangeContextSelector: (event, item) => {
        this.service.removeProfileItems();
        let link = this.service.getRedirectLink(this.windowRef.getHostname(), item);
        this.windowRef.setLocationHref(link);
      },
      onClickMenuItem: (event, item) => {
        this.router.navigateByUrl(item.path)
      },
      onClickLogout: (event) => {
        this.loginUrl$ = this.logout$ = this.auth.logout().subscribe(response => {
          this.service.removeProfileItems();
          this.windowRef.setLocationHref(response.url);
        });
      },
      onError: (error) => {
        if (error.status === 401 || error.status === 403 || error.status === 0) {
          this.loginUrl$ = this.auth.getLoginUrl().subscribe(response => {
            this.windowRef.setLocationHref(response.url);
          });
        }
      }
    }

    nc3navigation.init(options);
  }

}
